module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "control",
    staticClass: "control"
  }, [_c('transition', {
    attrs: {
      "name": "move"
    }
  }, [(_vm.food.count > 0) ? _c('svg', {
    staticClass: "icon",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.decrease($event)
      }
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-jian1"
    }
  })]) : _vm._e()]), _c('transition', {
    attrs: {
      "name": "move"
    }
  }, [(_vm.food.count > 0) ? _c('div', {
    staticClass: "count"
  }, [_vm._v(_vm._s(_vm.food.count))]) : _vm._e()]), _c('svg', {
    staticClass: "icon add",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.add($event)
      }
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-jia"
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-185099b8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cartcontrol.vue
// module id = 110
// module chunks = 0